import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import backArrowIcon from "../../assets/img/back-arrow.png";
import "../../assets/css/common.css";
import { useAuth } from "../../routers/AuthProvider";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import { truncateDecimal } from "../../utils/truncateDecimal";
import { Toast } from '../../components/ToastComponent';

export default function CreateProductPriceChange() {
  const backPath = `/product/price-change/list`;
  const {
    handleInputChange,
    formData,
    submitForm,
    setFormData,
    setError,
    error,
  } = useForm();

  useEffect(()=>{
          if(error){
             Toast.fire({
      title: error ,
      icon: "error",
    });
          }
      },[error])

  const navigate = useNavigate();
  const { user, setLoading } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedSubproductCategory, setSelectedSubproductCategory] =
    useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      ...formData,
      retail_price: truncateDecimal(formData.retail_price, 5),
      wholesale_price: truncateDecimal(formData.wholesale_price, 5),
      product_id: getProductId(selectedProduct),
    };
    submitForm("POST", "/product-price-change/create", data, () => {
      navigate(backPath);
    },"Successfully Created");
  };

  const [product, setProduct] = useState();
  const [barcode, setBarcode] = useState();
  const [units, setUnits] = useState();
  useEffect(() => {
    axios
      .get(API_URL + "/unit", {
        withCredentials: true,
      })
      .then((response) => {
        setUnits(response.data.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(API_URL + "/product?status=ACTIVE", {
        withCredentials: true,
      })
      .then((response) => {
        setProduct(response.data.data);
      });
  }, []);

  const productData = Array.from(
    new Set(product && product.map((product) => product.product_name))
  );

  const getProductId = (selectProduct) => {
    const selectedProduct =
      product &&
      product.find((category) => category.product_name === selectProduct);
    return selectedProduct ? selectedProduct.product_id : null;
  };

  return (
    <div className="sub-page-layout-1">
      <Link className="back-to-page" to={backPath}>
        <img src={backArrowIcon} />
        Back
      </Link>
      <div className="container" style={{ height: "auto" }}>
        <h1 className="sub-page-title">Create New Product Price Change</h1>
        <div className="form-container">
          <form
            onSubmit={onSubmit}
            className="form flex flex-col justify-between w-full"
          >
            <div className="grid grid-cols-2 gap-9">
              <div className="grow">
                <label className="x-label input-required">Product Name</label>
                <div className="dd-container">
                  <select
                    type="text"
                    required
                    name="product_id"
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    value={selectedProduct}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {productData.map((product) => (
                      <option
                        key={product.product_id}
                        value={product.product_name}
                      >
                        {product}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grow">
                <label className="x-label input-required">SKU</label>
                <div className="dd-container">
                  <select
                    type="text"
                    required
                    name="sku_unit_id"
                    defaultValue=""
                    onChange={handleInputChange}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {units &&
                      units.filter((item) => item.status === "ACTIVE")
                      .map((item, index) => (
                        <option key={index} value={item.unit_id}>
                          {item.unit_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* <div className='grow'>
                                <label className='x-label input-required'>Expired Date</label>
                                <input type="date"
                                    required
                                    name="expired_date"
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div> */}

              <div className="grow">
                <label className="x-label input-required">Currency Type</label>
                <div className="dd-container">
                  <select
                    type="text"
                    required
                    name="currency"
                    defaultValue=""
                    onChange={handleInputChange}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="BAHT">THB</option>
                    <option value="MMK">MMK</option>
                  </select>
                </div>
              </div>

              <div className="grow">
                <label className="x-label input-required">
                  Retail Sale Price
                </label>
                <input
                  type="number"
                  required
                  min={1}
                  step={0.001}
                  inputMode='numeric'
                  pattern='[0-9]*'
                  name="retail_price"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>

              <div className="grow">
                <label className="x-label input-required">
                  Wholesale Price
                </label>
                <input
                  type="number"
                  required
                  min={1}
                  step={0.001}
                  inputMode='numeric'
                  pattern='[0-9]*'
                  name="wholesale_price"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>
            </div>
            <div className="form-btn-group">
              {/* {error ? (
                <span className="w-full block text-lg text-red-500 text-right">
                  {error}
                </span>
              ) : (
                ""
              )} */}
              <div className="flex justify-end gap-5 mt-5">
                <Link to={backPath} className="white-btn">
                  Cancel
                </Link>
                <button type="submit" className="gold-btn">Create</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
